/* eslint-disable import/prefer-default-export */

export const SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE';
export const SET_PERSISTENT_VARIABLE = 'SET_PERSISTENT_VARIABLE';
export const CLEAR_PERSISTENT_VARIABLES = 'CLEAR_PERSISTENT_VARIABLES';